import { defineStore, acceptHMRUpdate } from 'pinia';
import useUiPlanningStore from '@/stores/ui/planning';
import usePlanningStore from '@/stores/planning/planning';
import usePlanningElementsStore from '@/stores/planning/elements';

const store = defineStore('selection', {
  state: () => ({
    selection: new Set(),
  }),
  getters: {
    selectionCount: state => state.selection.size,
  },
  actions: {
    reset(newsel) {
      if (useUiPlanningStore().doNotResetSelection) return;
      // Newsel array containing new values for selection
      this.selection.clear();
      if (newsel) {
        newsel.forEach((elId) => {
          this.selection.add(elId);
        });
      }
    },
    duplicateSelection() {
      const { planning } = usePlanningStore();
      const lane = planning.lanes[0];

      const duplicateTab = [];
      this.selection.forEach((id) => {
        const el = planning.elements.find(item => item.id == id);
        if (el) duplicateTab.push({ type: el.getType(), lane, el });
      });

      const newels = usePlanningElementsStore().addElements({ argstab: duplicateTab });
      const newselect = newels.map(newel => newel.id);
      this.reset(newselect);
    },
    deleteSelection() {
      const { planning } = usePlanningStore();
      const deleteTab = [];
      this.selection.forEach((id) => {
        const el = planning.elements.find(item => item.id == id);
        if (el) deleteTab.push(el);
      });
      usePlanningElementsStore().deleteElements({ els: deleteTab });
      this.reset();
    },
  },
});

if (import.meta.hot) import.meta.hot.accept(acceptHMRUpdate(store, import.meta.hot));
export default store;
